// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-components-Table-Cells-CellDynamicApproval-___CellDynamicApproval-module__readContainer {
  padding: 3px;
  text-align: center;
  height: 100%;
  background-color: rgb(239, 239, 239);
  overflow: hidden;
  border: 1px solid transparent;
}

.app-components-Table-Cells-CellDynamicApproval-___CellDynamicApproval-module__status {
  font-size: 15px;
  font-weight: bold;
  text-align: center;
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  position: relative;
}

.app-components-Table-Cells-CellDynamicApproval-___CellDynamicApproval-module__assignedUser {
  float: right;
  font-size: 12px;
  font-weight: bold;
}

.app-components-Table-Cells-CellDynamicApproval-___CellDynamicApproval-module__summaryTitle {
  font-size: 13px;
  font-weight: bold;
  flex: 1;
}

.app-components-Table-Cells-CellDynamicApproval-___CellDynamicApproval-module__comment {
  height: calc(100% - 60px);
  overflow-y: auto;
  overflow-x: hidden;
  padding: 5px;
  position: relative;
  z-index: 1;
}

.app-components-Table-Cells-CellDynamicApproval-___CellDynamicApproval-module__date {
  text-align: start;
  font-size: 12px;
  flex: 1;
  white-space: nowrap;
}

.app-components-Table-Cells-CellDynamicApproval-___CellDynamicApproval-module__statusOnlyRead {
  height: 100%;
  width: 100%;
  font-weight: bolder;
}

.app-components-Table-Cells-CellDynamicApproval-___CellDynamicApproval-module__top {
  height: 24px;
}

.app-components-Table-Cells-CellDynamicApproval-___CellDynamicApproval-module__isCollapsedTextIcon {
  padding: 1px 8px;
  background-color: white;
  border-radius: 3px;
}

.app-components-Table-Cells-CellDynamicApproval-___CellDynamicApproval-module__isCollapsedTextIcon:hover {
  color: rgba(0, 0, 0, 0.7);
}
`, "",{"version":3,"sources":["webpack://./app/components/Table/Cells/CellDynamicApproval/CellDynamicApproval.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,oCAAoC;EACpC,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,OAAO;AACT;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,OAAO;EACP,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".readContainer {\n  padding: 3px;\n  text-align: center;\n  height: 100%;\n  background-color: rgb(239, 239, 239);\n  overflow: hidden;\n  border: 1px solid transparent;\n}\n\n.status {\n  font-size: 15px;\n  font-weight: bold;\n  text-align: center;\n  width: 100%;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  position: relative;\n}\n\n.assignedUser {\n  float: right;\n  font-size: 12px;\n  font-weight: bold;\n}\n\n.summaryTitle {\n  font-size: 13px;\n  font-weight: bold;\n  flex: 1;\n}\n\n.comment {\n  height: calc(100% - 60px);\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 5px;\n  position: relative;\n  z-index: 1;\n}\n\n.date {\n  text-align: start;\n  font-size: 12px;\n  flex: 1;\n  white-space: nowrap;\n}\n\n.statusOnlyRead {\n  height: 100%;\n  width: 100%;\n  font-weight: bolder;\n}\n\n.top {\n  height: 24px;\n}\n\n.isCollapsedTextIcon {\n  padding: 1px 8px;\n  background-color: white;\n  border-radius: 3px;\n}\n\n.isCollapsedTextIcon:hover {\n  color: rgba(0, 0, 0, 0.7);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"readContainer": `app-components-Table-Cells-CellDynamicApproval-___CellDynamicApproval-module__readContainer`,
	"status": `app-components-Table-Cells-CellDynamicApproval-___CellDynamicApproval-module__status`,
	"assignedUser": `app-components-Table-Cells-CellDynamicApproval-___CellDynamicApproval-module__assignedUser`,
	"summaryTitle": `app-components-Table-Cells-CellDynamicApproval-___CellDynamicApproval-module__summaryTitle`,
	"comment": `app-components-Table-Cells-CellDynamicApproval-___CellDynamicApproval-module__comment`,
	"date": `app-components-Table-Cells-CellDynamicApproval-___CellDynamicApproval-module__date`,
	"statusOnlyRead": `app-components-Table-Cells-CellDynamicApproval-___CellDynamicApproval-module__statusOnlyRead`,
	"top": `app-components-Table-Cells-CellDynamicApproval-___CellDynamicApproval-module__top`,
	"isCollapsedTextIcon": `app-components-Table-Cells-CellDynamicApproval-___CellDynamicApproval-module__isCollapsedTextIcon`
};
export default ___CSS_LOADER_EXPORT___;
